import { ButtonHTMLAttributes } from 'react';

import { CheckIcon } from '../../../../../assets/svg/CheckIcon';
import { RecurrentPayIcon } from '../../../../../assets/svg/payment-links-types/RecurrentPay';
import { UniquePayIcon } from '../../../../../assets/svg/payment-links-types/UniquePay';
import {
	IconWrapper,
	PLCardContainer,
	PLCardIcon,
	PLCardSubtitle,
	PLCardTitle,
	PLContent,
	TextWrapper,
} from './styles';

interface PLCardProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	payType: 'unique' | 'recurrent';
	selected?: boolean;
	onClick?: () => void;
	disabled?: boolean;
}

const PLCardLink = ({ payType, selected = false, onClick, disabled }: PLCardProps) => {
	const handleClick = () => {
		if (onClick && !disabled) {
			onClick();
		}
	};

	return (
		<PLCardContainer selected={selected} onClick={handleClick}>
			<IconWrapper>
				{disabled && selected && <CheckIcon selected={selected} />}
				{!disabled && <CheckIcon selected={selected} />}
			</IconWrapper>
			<PLContent>
				<PLCardIcon selected={selected}>
					{payType === 'unique' ? (
						<UniquePayIcon disabled={!selected} />
					) : (
						<RecurrentPayIcon disabled={!selected} />
					)}
				</PLCardIcon>
				<TextWrapper>
					<PLCardTitle selected={selected}>
						{payType === 'unique' ? 'Cobro único' : 'Uso múltiple'}
					</PLCardTitle>
					<PLCardSubtitle selected={selected}>
						{payType === 'unique'
							? 'Para recibir un solo pago'
							: 'Para recibir varios pagos de uno o más clientes'}
					</PLCardSubtitle>
				</TextWrapper>
			</PLContent>
		</PLCardContainer>
	);
};

export { PLCardLink };
